import React, { useState } from "react";
import { NestedMenuItem } from "../../Tools/NestedMenuOrigin/NestedMenuItem";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ImgURL, XMLrequest } from "../../../Url";
import { getSectionByID } from "../../Tools/Tools";
import { ListItemText } from "@mui/material";
import { useAtomValue, useSetAtom } from "jotai";
import { currentTheme, setSelectedSectionAtom } from "../../../../atoms";

export default function SideBarButton(props) {
  const theme = useAtomValue(currentTheme);
  const colorTextButton = theme === "light" ? "#535353" : "white";
  const setSelectedSection = useSetAtom(setSelectedSectionAtom);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [data, setData] = useState(undefined);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (data === undefined) {
      let params = new Map(),
        json;
      params.set("comand", "GetSectionList");
      params.set("Simple", "0");
      params.set("full", "1");
      params.set(`png`, `1`);
      json = XMLrequest(params);
      setData(json["Sections"]);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function UpdateSelected(event) {
    let ID;
    ID = event.currentTarget.getAttribute("id");
    setSelectedSection(getSectionByID(ID));
    setAnchorEl(null);
  }

  function MenuButton(SectionList) {
    if (SectionList !== undefined) {
      let Name, ID, Img, CLSID;
      let assemblyLists = [];
      for (const [key, value] of Object.entries(SectionList)) {
        Name = SectionList[key]["Name"];
        ID = SectionList[key]["ID"];
        CLSID = SectionList[key]["CLSID"];
        // currentDeep = SectionList[key]["Deep"];
        Img = ImgURL(SectionList[key]["Image"], {
          height: "32px",
          width: "32px",
        });
        // Img = ImgBASE64(SectionList[key]["RCDATA"]);
        // keyS += 1;
        //   mainCollapse = data2.get(ID);
        //   mainCollapseID = ID;
        //   openSet = data2.get(ID);
        //   openSetID = ID;

        if (value["Sections"] !== undefined) {
          assemblyLists.push(
            <Grid key={key}>
              <NestedMenuItem
                leftIcon={Img}
                label={Name}
                parentMenuOpen={true}
                id={ID}
                CLSID={CLSID}
                onClick={UpdateSelected}
                style={{ position: "relative", top: "5px" }}
              >
                {MenuButtonItems(value["Sections"])}
              </NestedMenuItem>
            </Grid>,
          );
        } else {
          assemblyLists.push(
            <Grid key={key}>
              <MenuItem id={ID} CLSID={CLSID} style={{ paddingLeft: "4px" }} onClick={UpdateSelected}>
                <Grid>{SectionList[key]["Image"] ? Img : ""}</Grid>
                <ListItemText
                  variant="body1"
                  sx={{ pl: SectionList[key]["Image"] ? 1 : 0, pd: 1, alignSelf: "center" }}
                >
                  {Name}
                </ListItemText>
              </MenuItem>
            </Grid>,
          );
        }
      }
      return assemblyLists;
    }
  }

  function MenuButtonItems(SectionList) {
    let Name, ID, currentDeep, openSet, Img, CLSID;
    let assemblyLists = [];
    for (const [key, value] of Object.entries(SectionList)) {
      Name = SectionList[key]["Name"];
      ID = SectionList[key]["ID"];
      currentDeep = SectionList[key]["Deep"];
      Img = ImgURL(SectionList[key]["Image"], {
        height: "32px",
        width: "32px",
      });
      CLSID = SectionList[key]["CLSID"];
      //Img = ImgBASE64(SectionList[key]["RCDATA"]);
      // keyS += 1;
      //если ключ НЕ необъявен и след deep больше текущего, то рисуем родителя
      // openSetDeep = openSet;
      if (value["Sections"] !== undefined) {
        assemblyLists.push(
          <Grid key={key}>
            <NestedMenuItem
              leftIcon={Img}
              label={Name}
              parentMenuOpen={true}
              id={ID}
              CLSID={CLSID}
              onClick={UpdateSelected}
              style={{ alignSelf: "center" }}
            >
              {MenuButtonItems(value["Sections"])}
            </NestedMenuItem>
          </Grid>,
        );
      } else {
        assemblyLists.push(
          <Grid key={key}>
            <MenuItem style={{ paddingLeft: "4px" }} id={ID} CLSID={CLSID} onClick={UpdateSelected}>
              <Grid>{SectionList[key]["Image"] ? Img : ""}</Grid>
              <ListItemText variant="body1" sx={{ pl: SectionList[key]["Image"] ? 1 : 0, pd: 1, alignSelf: "center" }}>
                {Name}
              </ListItemText>
            </MenuItem>
          </Grid>,
        );
      }
    }
    return assemblyLists;
  }

  return (
    <Grid style={{ ...props.style }}>
      <Button
        size="small"
        onClick={handleClick}
        variant="text"
        style={{
          textTransform: "none",
          paddingTop: "6px",
          fontSize: "0.875rem",
          color: colorTextButton,
        }}
      >
        Выбрать
      </Button>
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        style={{ paddingTop: "0px", paddingBottom: "0px" }}
        sx={{ pt: 0, pb: 0 }}
      >
        {MenuButton(data)}
      </Menu>
    </Grid>
  );
}
